import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Lista Business Units ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NextTable, {
          class: "rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4",
          cols: _ctx.cols,
          "onUpdate:cols": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cols) = $event)),
          rows: _ctx.rows
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.rows, (c, j) => {
            return {
              name: `td_${j}_2`,
              fn: _withCtx((context) => [
                _createElementVNode("input", {
                  type: "checkbox",
                  disabled: "",
                  checked: c.show_crm
                }, null, 8, _hoisted_4)
              ])
            }
          }),
          _renderList(_ctx.rows, (c, j) => {
            return {
              name: `td_${j}_3`,
              fn: _withCtx((context) => [
                _createElementVNode("input", {
                  type: "checkbox",
                  disabled: "",
                  checked: c.show_progetti
                }, null, 8, _hoisted_5)
              ])
            }
          }),
          _renderList(_ctx.rows, (c, j) => {
            return {
              name: `td_${j}_4`,
              fn: _withCtx((context) => [
                _createVNode(_component_router_link, {
                  to: {name:'DettaglioBusinessUnit', params:{id:context.context.row.id}},
                  class: "text-center inset-0 absolute flex items-center justify-center"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["to"])
              ])
            }
          })
        ]), 1032, ["cols", "rows"])
      ])
    ])
  ]))
}